type Size = 'small' | 'medium' | 'large' | undefined;

export const calculateMinWidthBySize = (size: Size): string => {
  if (!size) {
    return '101px';
  }
  switch (size) {
    case 'small':
      return '103px';
    case 'medium':
      return '148px';
    case 'large':
      return '196px';
  }
};

export const calculatePaddingBySize = (size: Size): string => {
  if (!size) {
    return '8px 16px';
  }
  switch (size) {
    case 'small':
      return '6px 12px';
    case 'medium':
      return '8px 16px';
    case 'large':
      return '12px 24px';
  }
};

export const calculatePaddingLeftBySizeForIconButton = (size: Size): string => {
  if (!size) {
    return '20px';
  }
  switch (size) {
    case 'small':
      return '16px';
    case 'medium':
      return '20px';
    case 'large':
      return '28px';
  }
};
